import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, X } from 'lucide-react';

/**
 * TourPrompt - subtle non-intrusive prompt shown 1.5s after dashboard load.
 * "Take a quick 30-second tour" — user accepts to start the tour.
 */
const TourPrompt = ({ isOpen, onAccept, onDismiss }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: 24, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.96 }}
          transition={{ type: 'spring', stiffness: 240, damping: 26 }}
          className="fixed bottom-4 inset-x-0 mx-auto z-[60] w-[min(94vw,420px)]"
          data-testid="tour-prompt"
        >
          <div className="relative rounded-2xl border border-amber-400/30 bg-slate-900/95 backdrop-blur-xl shadow-2xl shadow-amber-500/10 overflow-hidden">
            {/* Top row: icon + copy + dismiss */}
            <div className="flex items-start gap-3 px-4 pt-3.5 pb-3">
              <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-gradient-to-br from-amber-400 to-amber-500 flex items-center justify-center shadow-lg shadow-amber-500/30">
                <Sparkles className="w-5 h-5 text-slate-900" />
              </div>
              <div className="flex-1 min-w-0 pt-0.5">
                <p className="text-sm font-semibold text-white leading-tight">Take a quick 30-second tour</p>
                <p className="text-xs text-slate-400 mt-0.5 leading-snug">We&apos;ll walk you through the essentials</p>
              </div>
              <button
                onClick={onDismiss}
                data-testid="tour-prompt-dismiss"
                aria-label="Dismiss tour prompt"
                className="flex-shrink-0 -mt-1 -mr-1 p-1.5 rounded-lg text-slate-500 hover:text-slate-300 hover:bg-slate-800 transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            {/* Action row — full-width on mobile so it never clips */}
            <div className="px-4 pb-3">
              <button
                onClick={onAccept}
                data-testid="tour-prompt-accept"
                className="w-full px-4 py-2.5 rounded-lg bg-amber-500 hover:bg-amber-400 text-slate-900 text-sm font-semibold transition-colors"
              >
                Show me
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TourPrompt;
